import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { createRoot } from "react-dom/client";
import Modal from "react-modal";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Provider as URQLProvider, cacheExchange, createClient, fetchExchange } from "urql";
import { AlertProvider } from "../../shared/components/Alerts";
import { JsDataGlobalNotice } from "../../shared/components/GlobalNotice";
import sentryExchange from "../../shared/sentryExchange";
import { CurrentPersonProvider } from "../CurrentPerson";
import { store } from "../state";
import BuilderRoutes from "./BuilderRoutes";

const client = createClient({
    exchanges: [cacheExchange, sentryExchange, fetchExchange],
    fetchOptions: {
        credentials: "same-origin",
        headers: {
            "X-CSRFToken": __CSRF_TOKEN__,
        },
    },
    requestPolicy: "cache-and-network",
    url: "/graphql/public",
});

// init function
export default function init() {
    const container = document.getElementById("builder-page");
    Modal.setAppElement(container);
    const root = createRoot(container);
    root.render(
        <URQLProvider value={client}>
            <ReduxProvider store={store}>
                <AlertProvider>
                    <BrowserRouter>
                        <CurrentPersonProvider>
                            <DndProvider backend={HTML5Backend}>
                                <JsDataGlobalNotice />
                                <BuilderRoutes />
                            </DndProvider>
                        </CurrentPersonProvider>
                    </BrowserRouter>
                </AlertProvider>
            </ReduxProvider>
        </URQLProvider>,
    );
}
